import { controlStylingConstants } from "@1js/acui-common";

export const nextStylesMLRBottomBarHeight = 100;
export const bottomBarHeightSLR = controlStylingConstants.controlHeight;
export const baseTopBarHeight = 36;
export const slrDividerPadding = 4;
export const vNextRibbonModeSwitcherLeftRightMargin = 4;
